import Vue from "vue";
import App from "./App.vue";
import "bootstrap/dist/css/bootstrap.css";
import 'jquery/src/jquery.js'
import 'bootstrap/dist/js/bootstrap.min.js'
import router from "./router";
import axios from "axios";
import Message from "@/components/common/Message";
import Spinner from "@/components/common/Spinner";
import MaterialSvg from "@/components/common/MaterialSvg";
import { Getter as SessionGetter } from "@/store/session/types";
import { Action as UserAction } from '@/store/user/types';
import { store } from "./store/";
import "@/assets/scss/main.scss";
import i18n from "./i18n";
import Hotjar from 'vue-hotjar'


Vue.component("Message", Message);
Vue.component("Spinner", Spinner);
Vue.component("MaterialSvg", MaterialSvg);

Vue.prototype.$http = axios;
Vue.config.productionTip = false;

Vue.use (Hotjar, {
  id: '2701680',
  isProduction: true,
  snippetVersion: 6
})

new Vue({
  store,
  router,
  axios,
  i18n,
  created() {
    this.checkAuthenticated();
    this.fetchInitialData();
  },
  methods: {
    checkAuthenticated() {
      let isAuth = this.$store.getters[`${SessionGetter.IS_AUTHENTICATED}`];
      if(isAuth) {
        axios.defaults.headers.common["Authorization"] =
            "Bearer " + this.$store.getters[`${SessionGetter.GET_TOKEN}`];
      }
    },
    fetchInitialData() {
      this.$store.dispatch(`${UserAction.GET_USER_DATA}`).then(() => {
        console.log("loaded user");
      });
    },
  },
  render: (h) => h(App)
}).$mount("#app");
